import {
  DetailSectionItem,
  DetailSection as DetailSectionType,
} from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import DateRange from '../common/DateRange';
import Summary from '../common/Summary';
import { Box, SectionHeading, SectionItemHeading, Text } from '../common/ui';
import { detailItemsFromSection } from '../common/utils';

const DetailSection = ({
  section,
  currentDateString,
}: {
  section: DetailSectionType;
  currentDateString?: string | null;
}) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const items = detailItemsFromSection(section);
  return (
    <Box as="section" variant="sectionContainer">
      <SectionHeading>{section.title}</SectionHeading>
      {items.map((item: DetailSectionItem) => {
        const dateRange = (
          <DateRange
            startDate={item.startDate}
            stopDate={item.stopDate}
            isCurrent={item.isCurrent}
            currentDateString={currentDateString}
          />
        );
        return (
          <Box
            variant="detailSectionItemContainer"
            sx={{
              display: 'flex',
              flexDirection: ['column', 'row'],
              pageBreakInside: 'avoid',
            }}
            key={item.id}
          >
            <Text variant="leftColumn">
              <SectionItemHeading url={item.website}>
                {item.title}
              </SectionItemHeading>
              <Text mb={calcSize(0.5)}>{dateRange}</Text>
            </Text>
            <Box>
              <Text
                variant="heading"
                sx={{
                  marginBottom: [4, calcSize(0.625)],
                }}
              >
                {item.subtitle}
              </Text>
              <Summary summary={item.summary} textType={item.textType} />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default DetailSection;
